<!-- Refund Modal -->
<p-dialog [(visible)]="showRefundModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '850px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div class="sticky left-0 top-0 z-1 surface-0 py-3 px-4 flex align-items-center justify-content-between border-bottom-1 border-300">
          <h2 class="mb-0 text-sm" [innerHTML]="'SALES_RETURN.SALES_RETURN_FOR' | translate : { name: invoiceData.billing_name, id: invoiceData.client_id }"></h2>
          <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup(false)"></div>
      </div>
      <!-- Header -->
      <form [formGroup]="clientSalesReturnForm">
          <!-- Content -->
          <div class="px-3 pt-2 surface-50">
              <!-- Heading -->
              <div class="text-right mb-2">
                  <h2 class="text-xl mb-0">{{'SALES_RETURN.SALES_RETURN' | translate}}</h2>
                  <p class="mb-0 text-xs" [innerHTML]="'SALES_RETURN.FOR_INVOICE' | translate : { number_prefix: invoiceData.number_prefix }"></p>
              </div>
              <!-- Heading -->

              <!-- Table -->
              <p-table [value]="(salesReturnServices$ | async)!" styleClass="p-0 border-top-1 border-bottom-1 border-300 m-0" responsiveLayout="scroll">
                  <ng-template pTemplate="header">
                      <tr>
                          <th class="surface-100 border-none w-22rem"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.PRODUCT_NAME' | translate}}</span></th>
                          <th class="surface-100 border-none"><span class="text-xs text-600 white-space-nowrap"></span></th>
                          <th class="surface-100 border-none"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.INVOICE_AMOUNT' | translate}}</span></th>
                          <th class="bg-blue-100 border-none border-left-1"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.QTY' | translate}}</span></th>
                          <th class="bg-blue-100 border-none"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.SALES_RETURN' | translate}}</span></th>
                          <th class="bg-blue-100 border-none"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.DESCRIPTION' | translate}}</span></th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-service>
                      <tr class="text-sm">
                          <td class="py-2 white-space-nowrap" [ngClass]="service.is_total_column ? 'surface-100' : 'surface-50' ">
                              <div *ngIf="!service.is_total_column; else elseBlock">{{service.name_primary_language}}</div>
                              <ng-template #elseBlock> </ng-template>
                          </td>
                          <td class="py-2 white-space-nowrap" [ngClass]="service.is_total_column ? 'surface-100' : 'surface-50' ">
                              <div *ngIf="service.is_total_column"><strong>{{service.name_primary_language}}</strong></div>
                          </td>
                          <td class="py-2 white-space-nowrap" [ngClass]="service.is_total_column ? 'surface-100' : 'surface-50' ">
                              <div *ngIf="!service.is_total_column!; else elseBlock2">{{service.invoice_amount | currencyformat}}</div>
                              <ng-template #elseBlock2>
                                  <strong>{{ getInvoiceTotalAmount | currencyformat }}</strong>
                              </ng-template>
                          </td>
                          <td class="py-2 white-space-nowrap border-left-1 border-300" [ngClass]="service.has_total_cell ? 'bg-blue-100' : 'bg-blue-50' ">
                              <div class="text-center" *ngIf="service.has_tax_cell"></div>
                              <div class="text-center font-bold" *ngIf="service.has_total_cell"></div>
                              <div *ngIf="(!service.has_tax_cell) && (!service.has_total_cell)" style="display: flex;align-items: center;">
                                  <!-- <p-inputNumber mode="decimal" [format]="false" inputStyleClass="w-3rem h-2rem" [min]="0" [max]="1000" [formControlName]="'service_quantity_'+service.invoice_line_id"></p-inputNumber> -->
                                  <app-input-number [formGroup]="clientSalesReturnForm" [controlName]="getSalesReturnFormControl('service_quantity_'+service.invoice_line_id)" 
                                   [styleClass]="'w-3rem text-sm'" [conditionToFormat]="false" (onBlur)="getSalesCalculation()">
                                 </app-input-number>
                                  <span style="font-weight: bold; padding: 5px;" *ngIf="service.type == 'Charge'">  of {{service.quantity}} </span>
                              </div>
                              <div class="text-xs p-error mt-1" *ngIf="getSalesReturnFormControl('service_quantity_'+service.invoice_line_id)  && getSalesReturnFormControl('service_quantity_'+service.invoice_line_id).hasError('max')">
                                  {{'SALES_RETURN.MSG.MAXIMIM_QUANTITY_REQUIRED' | translate : { quantity :service.quantity } }}
                              </div>
                          </td>
                          <td class="py-2 white-space-nowrap" [ngClass]="service.has_total_cell ? 'bg-blue-100' : 'bg-blue-50' ">
                              <div class="text-center" *ngIf="service.has_tax_cell">$5<sup>.00</sup></div>
                              <div class="text-center font-bold" *ngIf="service.has_total_cell">{{ getSalesReturnAmountTotal | currencyformat}}</div>
                              <div *ngIf="(!service.has_tax_cell) && (!service.has_total_cell)" class="p-inputgroup w-7rem">
                                  <span class="p-inputgroup-addon"> {{ currencySymbol$ | async }}</span>
                                  <!-- <p-inputNumber mode="decimal" [maxFractionDigits]="4" [format]="false" inputStyleClass="w-5rem h-2rem" [formControlName]="'service_sales_return_amount_'+service.invoice_line_id" (onBlur)="getSalesCalculation()"> </p-inputNumber> -->
                                  <app-input-number [formGroup]="clientSalesReturnForm" [controlName]="getSalesReturnFormControl('service_sales_return_amount_'+service.invoice_line_id)" 
                                  [styleClass]="'w-5rem text-sm'" [conditionToFormat]="false" (onBlur)="getSalesCalculation()">
                                </app-input-number>
                              </div>
                              <div
                                  class="text-xs p-error mt-1" *ngIf="getSalesReturnFormControl('service_description_'+service.invoice_line_id) && getSalesReturnFormControl('service_sales_return_amount_'+service.invoice_line_id).hasError('max')">
                                  {{'SALES_RETURN.MSG.MAXIMIM_REQUIRED' | translate : { amount :service.invoice_amount | currencyformat } }}
                              </div>
                          </td>
                          <td class="py-2 white-space-nowrap" [ngClass]="service.has_total_cell ? 'bg-blue-100' : 'bg-blue-50' ">
                              <div class="text-center" *ngIf="service.has_tax_cell"></div>
                              <div class="text-center font-bold" *ngIf="service.has_total_cell"></div>
                              <div *ngIf="(!service.has_tax_cell) && (!service.has_total_cell)">
                                  <input type="text" class="w-full text-sm" pInputText placeholder="" [formControlName]="'service_description_'+service.invoice_line_id" />
                              </div>
                              <div class="text-xs p-error mt-1" *ngIf="getSalesReturnFormControl('service_description_'+service.invoice_line_id)  && getSalesReturnFormControl('service_description_'+service.invoice_line_id).dirty &&  getSalesReturnFormControl('service_description_'+service.invoice_line_id).invalid">
                                  {{'common.errors.validations.REQUIRED' | translate : {fieldlabel: "SALES_RETURN.LBL_DESC" | translate } }}
                              </div>
                          </td>
                      </tr>
                  </ng-template>
              </p-table>
              <!-- Table -->
          </div>
          <!-- Content -->

          <!-- Content -->
          <div class="py-3 px-4">
              <!-- Grid -->
              <div class="grid">
                  <!-- Form Group -->
                  <div class="col-12 md:col-6">
                      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.REASON_FOR_RETURN' | translate}}</label>
                      <p-select [options]="returnReasons" formControlName="reason" optionLabel="value" styleClass="text-sm w-full" filterBy="name" [placeholder]="'SALES_RETURN.REASON_PLACEHOLDER' | translate">
                          <ng-template pTemplate="selectedItem">
                              <div class="flex align-items-center" *ngIf="SalesReturnReasonFormControl.value">
                                  <div class="text-sm">{{'SALES_RETURN.REASONS.'+SalesReturnReasonFormControl.value.value | translate}}</div>
                              </div>
                          </ng-template>
                          <ng-template let-returnReason pTemplate="item">
                              <div class="text-sm">{{'SALES_RETURN.REASONS.'+returnReason.value | translate}}</div>
                          </ng-template>
                      </p-select>
                      <app-error-msg
                          styleClass="md:block"
                          *ngIf="SalesReturnReasonFormControl.dirty && SalesReturnReasonFormControl.invalid"
                          [errors]="SalesReturnReasonFormControl.errors"
                          [fieldLabel]="'SALES_RETURN.MSG.REASON_REQUIRED' | translate">
                      </app-error-msg>
                  </div>
                  <!-- Form Group -->
                  <!-- Form Group -->
                  <div class="col-12 md:col-6">
                      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.SALES_REP' | translate}}</label>
                      <staff-selector [formGroup]="clientSalesReturnForm" [controlName]="SalesRepFormControl" [canRepresetative]="isClientRepresentative" [claims]="claims" [styleClass]="'w-full text-sm py-0 align-items-center'">
                      </staff-selector>
                      <app-error-msg styleClass="md:block" *ngIf="SalesRepFormControl.dirty && SalesRepFormControl.invalid" [errors]="SalesRepFormControl.errors" [fieldLabel]="'SALES_RETURN.SALES_REP' | translate"> </app-error-msg>
                  </div>
                  <!-- Form Group -->

                  <!-- Form Group -->
                  <div class="col-12 md:col-12">
                      <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALES_RETURN.COMMENTS' | translate}}</label>
                      <input type="text" class="w-full text-sm" pInputText placeholder="Name" formControlName="comment" />
                      <app-error-msg
                          styleClass="md:block"
                          *ngIf="SalesReturnReasonCommentFormControl.dirty && SalesReturnReasonCommentFormControl.invalid"
                          [errors]="SalesReturnReasonCommentFormControl.errors"
                          [fieldLabel]="'SALES_RETURN.LBL_COMMENTS' | translate">
                      </app-error-msg>
                  </div>
                  <!-- Form Group -->
              </div>
              <!-- Grid -->
          </div>
          <!-- Content -->

          <!-- Content -->
          <div class="border-top-3 border-300">
              <h4 class="mb-0 text-sm font-normal border-bottom-1 border-300 py-3 px-4" [innerHTML]="'SALES_RETURN.SALES_RETURN_FOR' | translate : { name: invoiceData.billing_name, id: invoiceData.client_id }"></h4>

              <div class="py-3 px-4">
                  <!-- Table -->
                  <p-table [value]="refundCalculationData" styleClass="p-0 m-0" responsiveLayout="scroll" [loading]="TableLoader$ | async">
                      <ng-template pTemplate="header">
                          <tr>
                              <th class="surface-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.TOTAL_INV_AMT' | translate}}</span></th>
                              <th class="surface-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.TOTAL_PAYMENT_REC' | translate}}</span></th>
                              <th class="surface-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.TOTAL_SALES_RETURN' | translate}}</span></th>
                              <th class="bg-yellow-100 border-none py-2"><span class="text-xs text-600 white-space-nowrap">{{'SALES_RETURN.COLUMNS.EXCESS_AMT' | translate}}</span></th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-productsData>
                          <tr class="text-sm">
                              <td class="py-2 white-space-nowrap text-center">{{productsData.total_invoice_amt | currencyformat }}</td>
                              <td class="py-2 white-space-nowrap">{{productsData.total_payment_received | currencyformat}}</td>
                              <td class="py-2 white-space-nowrap">{{ (productsData.total_sales_return  + getSalesReturnAmountTotal) | currencyformat}}</td>
                              <td class="py-2 bg-yellow-50 white-space-nowrap"><strong>{{productsData.excess_amt_to_return | currencyformat}}</strong></td>
                          </tr>
                      </ng-template>
                  </p-table>
                  <!-- Table -->
              </div>
          </div>
          <!-- Content -->

          <!-- Modal Footer -->
          <div class="sticky left-0 bottom-0 z-1 surface-0 flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
              <p-button label="Cancel" styleClass="p-button-text text-sm" (click)="closePopup(false)"></p-button>
              <div *ngIf="chooseRefundPaymentMethods.value">
              <p-button [disabled]="!clientSalesReturnForm.valid" [label]="'SALES_RETURN.SALES_RETURN_AMOUNT' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }" icon="fa fa-chevron-down" iconPos="right" styleClass="text-sm"
                  (click)="clientSalesReturnForm.valid ? refundOptions.toggle($event) : null">
                </p-button>
                <p-popover #refundOptions styleClass="overflow-hidden right-0 text-sm w-18rem -ml-3">
                  <ng-template #content>
                    <ul class="list-none -m-4 py-2 px-0 text-xs text-900">
                      <li (click)="ProcessSalesReturn('credit')" class="cursor-pointer hover:surface-300 px-3 py-2 font-bold">{{'SALES_RETURN.REFUND_TO_E_WALLET' | translate }}</li>
                      <li (click)="refundBackToSource()" class="cursor-pointer hover:surface-300 px-3 py-2 font-bold">{{'SALES_RETURN.REFUND_BACK_TO_SOURCE' | translate }}</li>
                      <!-- <li (click)="offlineRefund()" class="cursor-pointer hover:surface-300 px-3 py-2 font-bold">Offline Refund <span class="font-normal">(Refund options on next screen)</span></li> -->
                    </ul>
                  </ng-template>
                </p-popover>
            </div>
            <div *ngIf="!chooseRefundPaymentMethods.value">
                <p-button [disabled]="!clientSalesReturnForm.valid" [label]="'SALES_RETURN.SALES_RETURN_AMOUNT' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }"  styleClass="text-sm"
                    (click)="ProcessSalesReturn('credit')">
                  </p-button>
              </div>
              <!-- <div class="flex align-items-center">
                  <p-button type="button" [label]="salesReturnAmount > 0 ? ('SALES_RETURN.BTN_CREDIT' | translate) : ('common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate)" styleClass="text-sm" (click)="ProcessSalesReturn()" [loading]="btnLoading | async" [disabled]="!clientSalesReturnForm.valid"></p-button>
              </div> -->
          </div>
          <!-- Modal Footer -->
      </form>
  </ng-template>
</p-dialog>
<!-- Refund Modal -->

<!-- Refund Confirm Modal -->
<p-dialog [(visible)]="refundConfirmModal" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '670px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <div class="relative text-center p-5 md:px-7">

      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="refundConfirmModal = false"></div>

        <i class="fa-solid fa-triangle-exclamation p-error text-7xl"></i>

      <h4 class="text-base md:text-lg my-3 font-normal"><strong class="font-bold">{{'SALES_RETURN.ARE_YOU_SURE' | translate}}</strong> <br class="hidden md:block">
        <div *ngIf="PaymentMethodDetails" [innerHTML]="'SALES_RETURN.THIS_ACTION_CANNOT_BE_UNDONE' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ), payment_method: PaymentMethodDetails.number }"></div>
      </h4>

      <div class="mt-5">
        <label class="font-medium text-700 text-xs mb-3 block uppercase">{{'SALES_RETURN.PLEASE_TYPE_REFUND_TO_CONFIRM' | translate}}</label>
        <input type="text" class="w-full text-sm" pInputText [formControl]="refundConfirmControl" placeholder="Type REFUND here">
        <small class="p-error block mt-2" *ngIf="refundConfirmControl.dirty && refundConfirmControl.invalid">
          {{'SALES_RETURN.PLEASE_TYPE_REFUND_TO_CONFIRM_ERROR' | translate}}
        </small>
      </div>

    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div class="flex align-items-center justify-content-between p-3 border-top-1 border-300">
      <p-button label="Cancel" styleClass="p-button-text text-sm" (click)="refundConfirmModal = false"></p-button>
      <p-button [label]="'SALES_RETURN.YES_REFUND' | translate : { amount: (getSalesReturnAmountTotal | currencyformat ) }" styleClass="text-sm" [disabled]="!refundConfirmControl.valid" (click)="ProcessSalesReturn('online')" [loading]="btnLoading.value"></p-button>
    </div>
    <!-- Modal Footer -->

  </ng-template>

</p-dialog>
<!-- Refund Confirm Modal -->
